const e=Object.freeze({invalid:"invalid",valid:"valid",untouched:"untouched"});export{e as VALIDITY};
